import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class AssuntoRtrValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (refs.idassuntortrerpInput.required && Util.isNull(model.idassuntortrerp)) {
            validated = false;
            refs.idassuntortrerpInput.focusedOut = true;
        }

        if (Util.isNull(model.descricao)) {
            validated = false;
            refs.descricaoInput.focusedOut = true;
        }

        

        return validated;
    }

}